<div>
    <h3 class="text-center">{{title}}</h3>
    <canvas id="{{chartId}}">{{ chart }}</canvas>
</div>